import React from "react"
import PrivacyProtection from "../components/domains/PrivacyProtection"
import FreeDomainServices from "../components/domains/FreeDomainServices"
import AppBlock from "../components/home/AppBlock"
import Seo from "../components/seo"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import PricingTld from "../components/ui/PricingTld"
import CurrencyContext from "../context/CurrencyContext"
import StaticLinuxHostingBlock from "../components/hosting/StaticLinuxHostingBlock"
import WebHosting from "../components/hosting/WebHosting"
import FeaturedTlds from "../components/domains/FeaturedTlds"
import NavLink from "../components/NavLink"
import parse from "html-react-parser"

const TldPage = ({ data, pageContext }) => {
  const lang = pageContext?.langKey
  const tldPricing = data.allTldsPricingJson.edges
  const tldData =
    data.allTldsJson.edges.length > 0 ? data.allTldsJson.edges[0].node : null

  return (
    <Layout>
      <Seo
        title={
          lang === "en-us"
            ? tldData.en_US.title
            : lang === "en-uk"
            ? tldData.en_GB.title
            : lang === "en-in"
            ? tldData.en_IN.title
            : `Register ` +
              tldPricing[0].node.tld +
              ` domain name today & Get Free Web Hosting | Motherhost`
        }
        desc={
          lang === "en-us"
            ? tldData.en_US.description
            : lang === "en-uk"
            ? tldData.en_GB.description
            : lang === "en-in"
            ? tldData.en_IN.description
            : `Motherhost offers Free ` +
              tldPricing[0].node.tld +
              ` Domain Name with 1 year all shared web hosting plan in UK`
        }
        pathname={`/tlds/` + tldPricing[0].node.slug + `-domain/`}
        keywords={
          lang === "en-us"
            ? tldData.en_US.keywords
            : lang === "en-uk"
            ? tldData.en_GB.keywords
            : lang === "en-in"
            ? tldData.en_IN.keywords
            : `Domain name provider ` +
              tldPricing[0].node.tld +
              `, free service with domain, domain registration, free domain registration`
        }
        bannerImage="/img/og/staticHostingOg.jpg"
      >
        <script type="application/ld+json">
          {`{
            "@context": "http://schema.org/",
            "@type": "Product",
            "name": "${tldPricing[0].node.tld}",
            "image": "https://www.motherhost.com/img/og/staticHostingOg.jpg",
            "description": "Register ${tldPricing[0].node.tld} domain name today & Get Free Web Hosting | Motherhost",
            "brand": {
                "@type": "Brand",
                "name": "Motherhost"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue" : "4.9",
              "reviewCount" : "110",
              "worstRating" : "1",
              "bestRating" : "5"
            }
          }`}
        </script>
      </Seo>
      <div className="content bg">
        <section className="position-relative py-3 pricing text-start">
          <div className="container-xl position-relative">
            <div className="row">
              <div className="col-12 col-lg-8 mb-3 mb-lg-0">
                <div className="py-5 px-4 bg-india-green h-100 position-relative">
                  <h1 className="page-title text-white mb-4 fs-36">
                    Get free web hosting with{" "}
                    <span className="bg-white text-dark px-2 rounded">
                      {tldPricing[0].node.tld}
                    </span>{" "}
                    domain name
                  </h1>
                  <form
                    action="https://my.motherhost.com/cart.php?a=add&amp;domain=register"
                    className="row "
                    method="post"
                  >
                    <div className="input-group position-relative">
                      <input
                        type="text"
                        name="sld"
                        className="form-control border-0"
                        placeholder="Let's get you that perfect Domain Name"
                      />
                      <input
                        type="submit"
                        value="Search"
                        className="btn btn-primary rounded-end"
                      />
                    </div>
                  </form>
                  <ul className="text-white list-unstyled mt-3">
                    <li className="d-flex">
                      <div className="">
                        <h2 className="title">
                          <CurrencyContext.Consumer>
                            {(context) => {
                              return (
                                <>
                                  {tldPricing.map((item, index) => (
                                    <div key={index}>
                                      <PricingTld
                                        pricing={item.node.pricing}
                                        tld={item.node.tld}
                                      />
                                    </div>
                                  ))}
                                </>
                              )
                            }}
                          </CurrencyContext.Consumer>
                        </h2>
                        <p className="text-white pb-3 description">
                          Transfer your {tldPricing[0].node.tld} Domain Name to
                          Motherhost to extend your domain by 1 year! *Free
                          domain transfer with every hosting purchase of annual
                          Plan.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <StaticLinuxHostingBlock />
            </div>
          </div>
        </section>
        <section className="pricing text-start">
          <div className="container-xl">
            <div className="row ">
              <FeaturedTlds />
            </div>
          </div>
        </section>
        <section className="cta-block">
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <h2 className="cta-heading">Explore .IN Domain Pricing</h2>
                <p className="cta-subheading">
                  Find the perfect domain for your website today. Discover
                  affordable pricing options for .IN domains.
                </p>
              </div>
              <div className="col-md-4">
                <NavLink
                  className="btn btn-width btn-primary"
                  to="/domains/in-domain-pricing/"
                >
                  View Pricing
                  <i className="bi bi-arrow-right float-end"></i>
                </NavLink>
              </div>
            </div>
          </div>
        </section>
        <section className="text-start pricing">
          <div className="container-xl ">
            <WebHosting />
          </div>
        </section>

        <FreeDomainServices />

        <section className="bg-white keey-away">
          <div className="container-fluid">
            <div className="row">
              <PrivacyProtection />
            </div>
          </div>
        </section>
        <AppBlock />
        {tldData && (
          <section className="faq-general">
            <div className="container-xl">
              <h4 className="component-title d-inline-block pb-4 text-center ui-heading">
                Frequently asked questions
              </h4>
              <div className="fea-heading text-dark-blue mb-4">
                {tldData.faq.subheading}
              </div>
              <div
                className="accordion accordion-flush"
                id="accordionFlushExample"
              >
                {tldData.faq.map((item, index) => (
                  <div className="accordion-item" key={index}>
                    <h5 className="accordion-header" id={"faqquestion" + index}>
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={"#faqanswer-" + index}
                        aria-expanded="false"
                        aria-controls="flush-collapseOne"
                      >
                        {item.question}
                      </button>
                    </h5>
                    <div
                      id={"faqanswer-" + index}
                      className="accordion-collapse collapse"
                      aria-labelledby={"faqquestion" + index}
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">{parse(item.answer)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}
      </div>
    </Layout>
  )
}

export default TldPage

export const PageQuery = graphql`
  query ($tld: String!) {
    allTldsPricingJson(filter: { tld: { eq: $tld } }) {
      edges {
        node {
          tld
          slug
          pricing {
            INR {
              prefix
              suffix
              register
              renew
            }
            MYR {
              prefix
              suffix
              register
              renew
            }
            SGD {
              prefix
              suffix
              register
              renew
            }
            USD {
              prefix
              suffix
              register
              renew
            }
            GBP {
              prefix
              suffix
              register
              renew
            }
          }
        }
      }
    }
    allTldsJson(filter: { tld: { eq: $tld } }) {
      edges {
        node {
          tld
          heading
          subheading
          description
          image
          en_GB {
            title
            lang
            keywords
            description
          }
          en_US {
            title
            lang
            keywords
            description
          }
          en_IN {
            title
            lang
            keywords
            description
          }
          faq {
            question
            answer
          }
        }
      }
    }
  }
`
